<script>
	let selected;
</script> 
<table border="0" width="100%" class="listtable layTemplate" id="SKOYS-layTemplate" style="display: table;">
                    <tbody>
                        <tr>
                            <td class="labelform">Data Pembanding</td>
                            <td width="1%" class="labelform">:</td>
                            <td data-title="Data Pembanding">
                                <select name="pembanding" id="pembanding" class="form-select w-full m-b-10" 
                                
            bind:value={selected}>
                                    <option value="0" selected="">Data Pembanding</option>
                                    <option value="1">BPJS/KIS</option>
                                    <option value="2">Buku Nikah</option>
                                    <option value="3">KKS</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                    {#if selected==3}
                    <tbody id="skoys_3" class="hide skoysToggle">
                        <tr>
                            <td colspan="3">
                                <h4>#Kartu Kesejahteraan Sosial</h4>
                
                            </td>
                        </tr>
                        <tr>
                            <td class="labelform">Nomor Kartu</td>
                            <td class="labelform">:</td>
                            <td data-title="Nomor Buku">
                                <input name="kks_nomor" id="bn_nomor" value="" type="text" placeholder="Nomor Kartu"
                                    class="form-input w-full skoys_3 skoysInput">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Nama</td>
                            <td class="labelform">:</td>
                            <td data-title="Nama">
                                <input name="kks_nama" id="bn_nama" value="" type="text" placeholder="Nama"
                                    class="form-input w-full skoys_3 skoysInput">
                            </td>
                        </tr>
                        <tr>
                        <td colspan="3">
                
                        </td>
                        </tr>
                    </tbody>
                {/if}
                {#if selected==2}
                    <tbody id="skoys_2" class="hide skoysToggle">
                        <tr>
                            <td colspan="3">
                                <h4>#Buku Nikah</h4>
                
                            </td>
                        </tr>
                        <tr>
                            <td class="labelform">Nomor Buku</td>
                            <td class="labelform">:</td>
                            <td data-title="Nomor Buku">
                                <input name="bn_nomor" id="bn_nomor" value="" type="text" placeholder="Nomor Buku Nikah"
                                    class="form-input w-full skoys_2 skoysInput">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Nama</td>
                            <td class="labelform">:</td>
                            <td data-title="Nama">
                                <input name="bn_nama" id="bn_nama" value="" type="text" placeholder="Nama"
                                    class="form-input w-full skoys_2 skoysInput">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Alamat di Buku</td>
                            <td class="labelform">:</td>
                            <td data-title="Alamat di Buku">
                                <input name="bn_almt" id="bn_almt" value="" type="text" placeholder="Alamat di Buku Nikah"
                                    class="form-input w-full skoys_2 skoysInput">
                            </td>
                        </tr>
                        <tr>
                
                        <tr>
                            <td class="labelform">Tanggal Lahir</td>
                            <td class="labelform">:</td>
                            <td data-title="Tanggal Lahir"><input id="bn_tgl" value="" name="bn_tgl" maxlength="10" type="date"
                                    class="form-input w-full skoys_2 skoysInput"></td>
                        </tr>
                        <tr>
                        <td colspan="3">
                
                        </td>
                        </tr>
                    </tbody>
                    {/if}
                    
                    {#if selected==1}
                    <tbody id="skoys_1" class="hide skoysToggle">
                        <tr>
                            <td colspan="3">
                
                                <h4>#Kartu Indonesia Sehat</h4>
                
                            </td>
                        </tr>
                        <tr>
                            <td class="labelform">Nomor Kartu</td>
                            <td class="labelform">:</td>
                            <td data-title="Nomor Kartu">
                                <input name="kis_nomor" id="kis_nomor" value="" type="text" placeholder="Nomor Kartu"
                                    class="form-input w-full skoys_1 skoysInput">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Nama</td>
                            <td class="labelform">:</td>
                            <td data-title="Nama">
                                <input name="kis_nama" id="kis_nama" value="" type="text" placeholder="Nama"
                                    class="form-input w-full skoys_1 skoysInput">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Alamat di Kartu</td>
                            <td class="labelform">:</td>
                            <td data-title="Alamat di Kartu">
                                <input name="kis_almt" id="kis_almt" value="" type="text" placeholder="Alamat di Kartu"
                                    class="form-input w-full skoys_1 skoysInput">
                            </td>
                        </tr>
                        <tr>
                
                        <tr>
                            <td class="labelform">Tanggal Lahir</td>
                            <td class="labelform">:</td>
                            <td data-title="Tanggal Lahir"><input id="kis_tgl" value="" name="kis_tgl" maxlength="10" type="date"
                                    class="form-input w-full skoys_1 skoysInput"></td>
                        </tr>
                
                        <tr>
                            <td class="labelform">Faskes Tingkat I</td>
                            <td class="labelform">:</td>
                            <td data-title="Faskes Tingkat I">
                                <input name="kis_faskes" id="kis_faskes" value="" type="text" placeholder="Faskes Tingkat I"
                                    class="form-input w-full skoys_1 skoysInput">
                            </td>
                        </tr>
                        <tr>
                        <td colspan="3">
                
                        </td>
                        </tr>
                    </tbody>
                    {/if}
                </table>